import React, { useState } from "react";
import ReturnIdPrompt from "./ReturnIdPrompt";
import { signInOne } from "./signoutData";

const SignInButton = ({ id, studentName, idNumber, requireIdOnReturn, onSignInAll }) => {
  const [loading, setLoading] = useState(false);
  const [prompting, setPrompting] = useState(false);

  const signIn = async () => {
    setLoading(true);
    try {
      await signInOne(id);
    } catch (err) {
      console.error(`Error signing in ${studentName}:`, err);
    } finally {
      setLoading(false);
    }
  };

  // No ID requirement (or none on file) → one-click sign-in
  const handleClick = () => {
    if (requireIdOnReturn && idNumber) {
      setPrompting(true);
    } else {
      signIn();
    }
  };

  return (
    <>
      <button className="signout-return-btn" onClick={handleClick} disabled={loading}>
        {loading ? "…" : "Sign In"}
      </button>

      {prompting && (
        <ReturnIdPrompt
          studentName={studentName}
          expectedId={idNumber}
          onConfirm={() => { setPrompting(false); signIn(); }}
          onConfirmAll={onSignInAll ? () => { setPrompting(false); onSignInAll(); } : undefined}
          onCancel={() => setPrompting(false)}
        />
      )}
    </>
  );
};

export default SignInButton;
